import { I18nCatalogue } from '../../frontend-lib/i18n/reservation/types'

export enum DayOfWeek {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export function getDayOfWeekLocaled(catalogue: I18nCatalogue, day: number) {
  switch (day) {
    case DayOfWeek.Sunday:
      return catalogue.dayOfWeek.sunday
    case DayOfWeek.Monday:
      return catalogue.dayOfWeek.monday
    case DayOfWeek.Tuesday:
      return catalogue.dayOfWeek.tuesday
    case DayOfWeek.Wednesday:
      return catalogue.dayOfWeek.wednesday
    case DayOfWeek.Thursday:
      return catalogue.dayOfWeek.thursday
    case DayOfWeek.Friday:
      return catalogue.dayOfWeek.friday
    case DayOfWeek.Saturday:
      return catalogue.dayOfWeek.saturday
    default:
      return ''
  }
}
